import React from 'react'
import { useTranslation } from 'react-i18next'

import ActionModal from 'components/Modal/ActionModal'

const ViewPreferenceModal = ({ viewMode, onDecision }) => {
  const { t } = useTranslation()
  const viewLabel = t(`supervision.hardware.view.${viewMode}`).toLowerCase()

  return (
    <ActionModal
      cancelLabel={t('ui_elements.no')}
      confirmLabel={t('ui_elements.yes')}
      description={t('supervision.hardware.view.preference.description', { view: viewLabel })}
      onClose={() => onDecision(false)}
      onConfirm={() => onDecision(true)}
      title={t('supervision.hardware.view.preference.title')}
      variant="primary"
    />
  )
}

export default ViewPreferenceModal
